var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css, useTheme } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { SvgIcon } from './svg-icon';
import { useComponentPropsFor } from '../context/icons-component-props-context';
var cls = classNames('circle-icon');
export var SvgCircleIconDefaultProps = {
  variant: 'default',
  strokeWidth: 8,
  viewBoxSize: 96,
  glyphFit: 'exact',
  glyphWidth: 40,
  glyphHeight: 40,
  glyphOffsetX: 0,
  glyphOffsetY: 0,
  size: 48,
  colors: {
    background: 'none'
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    flex-shrink: 0;\n\n    ", "\n    \n    ", "\n\n    ", "\n\n    ", " {\n      ", "\n    }\n\n    ", "\n  "], ["\n    flex-shrink: 0;\n\n    ", "\n    \n    ", "\n\n    ", "\n\n    ", " {\n      ", "\n    }\n\n    ", "\n  "])), function (_a) {
    var onClick = _a.onClick;
    return onClick && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      cursor: pointer;\n    "], ["\n      cursor: pointer;\n    "])));
  }, function (_a) {
    var colors = _a.colors;
    return colors.fill && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), theme.FILL(colors.fill));
  }, function (_a) {
    var _b, _c;
    var colors = _a.colors;
    return ((_b = colors.hover) === null || _b === void 0 ? void 0 : _b.fill) && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      &:hover {\n        ", ";\n      }\n    "], ["\n      &:hover {\n        ", ";\n      }\n    "])), theme.FILL((_c = colors.hover) === null || _c === void 0 ? void 0 : _c.fill));
  }, cls.dot('fill'), function (_a) {
    var colors = _a.colors;
    return colors.background && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        fill: ", ";\n      "], ["\n        fill: ", ";\n      "])), theme.COLOR(colors.background));
  }, function (_a) {
    var _b, _c;
    var colors = _a.colors;
    return ((_b = colors.hover) === null || _b === void 0 ? void 0 : _b.background) && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      &:hover ", " {\n        fill: ", ";\n      }\n    "], ["\n      &:hover ", " {\n        fill: ", ";\n      }\n    "])), cls.dot('fill'), theme.COLOR((_c = colors.hover) === null || _c === void 0 ? void 0 : _c.background));
  })
});
var FillStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var GlyphStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\n    ", "\n\n    ", "\n  "], ["\n\n    ", "\n\n    ", "\n  "])), function (_a) {
    var colors = _a.colors;
    return colors.fill && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      // these are used as a \"fill\" on the shape, but they apply to the lines of the icon\n      ", ";\n    "], ["\n      // these are used as a \"fill\" on the shape, but they apply to the lines of the icon\n      ", ";\n    "])), theme.FILL(colors.fill));
  }, function (_a) {
    var _b, _c;
    var colors = _a.colors;
    return ((_b = colors.hover) === null || _b === void 0 ? void 0 : _b.fill) && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      &:hover {\n        ", ";\n      }\n    "], ["\n      &:hover {\n        ", ";\n      }\n    "])), theme.FILL((_c = colors.hover) === null || _c === void 0 ? void 0 : _c.fill));
  })
});
var RingStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'SvgCircleIcon',
  Container: styled(SvgIcon)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Ring: styled.path.attrs(cls.attr('ring'))(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), RingStyles),
  Fill: styled.circle.attrs(cls.attr('fill'))(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), FillStyles),
  Glyph: styled.svg(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), GlyphStyles)
};
export var SvgCircleIcon = function (props) {
  var _a = useComponentPropsFor(My.NAME, SvgCircleIconDefaultProps, props),
    className = _a.className,
    children = _a.children,
    strokeWidth = _a.strokeWidth,
    colors = _a.colors,
    glyphOffsetX = _a.glyphOffsetX,
    glyphOffsetY = _a.glyphOffsetY,
    glyphWidth = _a.glyphWidth,
    glyphHeight = _a.glyphHeight,
    viewBoxSize = _a.viewBoxSize,
    onClick = _a.onClick,
    glyphFit = _a.glyphFit,
    rest = __rest(_a, ["className", "children", "strokeWidth", "colors", "glyphOffsetX", "glyphOffsetY", "glyphWidth", "glyphHeight", "viewBoxSize", "onClick", "glyphFit"]);
  var isGlyph = props.variant === 'glyph';
  var t = useTheme();
  var glyphX = !isGlyph ? glyphOffsetX + (viewBoxSize - props.glyphWidth) / 2 : rest.x || 0;
  var glyphY = !isGlyph ? glyphOffsetY + (viewBoxSize - props.glyphHeight) / 2 : rest.y || 0;
  var ratio = props.glyphWidth / props.glyphHeight;
  var viewBoxWidth = isGlyph ? ratio >= 1 ? viewBoxSize : viewBoxSize * ratio : viewBoxSize;
  var viewBoxHeight = isGlyph ? ratio > 1 ? viewBoxSize / ratio : viewBoxSize : viewBoxSize;
  var containerWidth = isGlyph && glyphFit !== 'fit' ? ratio >= 1 ? props.size : props.size * ratio : props.size;
  var containerHeight = isGlyph && glyphFit !== 'fit' ? ratio > 1 ? props.size / ratio : props.size : props.size;
  var resolvedGlyphWidth = isGlyph ? containerWidth : props.glyphWidth;
  var resolvedGlyphHeight = isGlyph ? containerHeight : props.glyphHeight;
  var viewBox = "0 0 ".concat(isGlyph ? containerWidth : viewBoxWidth, " ").concat(isGlyph ? containerHeight : viewBoxHeight);
  var hasFill = !!colors.fill && colors.fill !== 'none';
  var width = glyphFit === 'exact' ? resolvedGlyphWidth : props.size;
  var height = glyphFit === 'exact' ? resolvedGlyphHeight : props.size;
  var glyph = React.createElement(My.Glyph, {
    x: glyphX,
    y: glyphY,
    className: isGlyph && cls.name(className),
    colors: isGlyph && colors,
    overflow: "visible",
    width: isNaN(width) ? null : width,
    height: isNaN(height) ? null : height,
    preserveAspectRatio: isGlyph ? 'xMidYMid meet' : glyphFit === 'exact' ? 'none' : 'xMidYMid meet',
    viewBox: "0 0 ".concat(props.glyphWidth, " ").concat(props.glyphHeight)
  }, children);
  if (isGlyph) {
    return glyph;
  }
  var innerRadius = 40;
  var outerRadius = 48;
  var centerY = 48;
  var centerX = 48;
  var dRing = "\n    M ".concat(centerX, " ").concat(centerY - outerRadius, "\n    A ").concat(outerRadius, " ").concat(outerRadius, " 0 1 0 ").concat(centerX, " ").concat(centerY + outerRadius, "\n    A ").concat(outerRadius, " ").concat(outerRadius, " 0 1 0 ").concat(centerX, " ").concat(centerY - outerRadius, "\n    Z\n    M ").concat(centerX, " ").concat(centerY - innerRadius, "\n    A ").concat(innerRadius, " ").concat(innerRadius, " 0 1 1 ").concat(centerX, " ").concat(centerY + innerRadius, "\n    A ").concat(innerRadius, " ").concat(innerRadius, " 0 1 1 ").concat(centerX, " ").concat(centerY - innerRadius, "\n  ");
  return React.createElement(My.Container, __assign({}, rest, {
    onClick: onClick,
    colors: colors,
    width: containerWidth,
    height: containerHeight,
    className: cls.name(className),
    viewBox: viewBox
  }), !isGlyph && React.createElement(My.Ring, {
    d: dRing
  }), !isGlyph && hasFill && React.createElement(My.Fill, {
    cx: "48",
    cy: "48",
    r: "40.5"
  }), glyph);
};
/* @ts-ignore */
SvgCircleIcon.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;